// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon_leave_note.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_document_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("styles/img/icon-fee.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("styles/img/icon-exit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__localHeader___uYQkz {
}

.styles__localHeaderInner___KZ9n_ {
}

.styles__contentContainer___JP7Iu {
  display: flex;
  flex-direction: column;
}

.styles__eventsTable___bkUtF {
  width: 100%;
}

.styles__nextActionsTable___kuQ_5 {
  width: 95%;
  cursor: pointer;
}

.styles__section___fRz4j {
  min-height: 300px;
}

.styles__sectionTitle___TvCN8 {
  margin-bottom: 20px;
}

.styles__tableWrapper___u2wn6 {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__tableWrapper___u2wn6:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__tableWrapper___u2wn6:last-child {
  margin-right: 0;
}

.styles__tableWrapper___u2wn6:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__tableWrapper___u2wn6:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__tableWrapper___u2wn6 {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__tableWrapper___u2wn6:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__tableWrapper___u2wn6:last-child {
    margin-right: 0;
}

.styles__tableWrapper___u2wn6:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__tableWrapper___u2wn6:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__oneThird___WwVhK {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___WwVhK:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___WwVhK:last-child {
  margin-right: 0;
}

.styles__oneThird___WwVhK:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___WwVhK:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___WwVhK {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___WwVhK:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___WwVhK:last-child {
    margin-right: 0;
}

.styles__oneThird___WwVhK:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___WwVhK:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__row___u6G8a {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__buttonLocal___HWYYk {
  margin-right: 20px;
  margin-bottom: 20px;
}

.styles__smallFixedCell___k8YPZ {
  width: 50px;
}

.styles__iconLink___awf2T {
  cursor: pointer;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  -webkit-box-shadow: none !important;
}

.styles__collapseRef___fAoZt {
}

.styles__collapseRef___fAoZt[data-active='true'] .styles__collapseIcon___Gvspn {
      transform: rotate(180deg);
    }

.styles__title___qEfAc {
  flex: 1;
}

.styles__titleSection___eu_E3 {
  position: relative;
}

.styles__titleSection___eu_E3:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___eu_E3 .styles__name___Fzce0 {
    transition: all 0.25s;
  }

.styles__titleSection___eu_E3 .styles__noName___at_Ox {
    margin-top: 2px;
  }

.styles__sectionNoMargin___td5ua {
}

.styles__docsWrapper___TNijY {
  background: white;
  border-radius: 0 0 3px 3px;
}

.styles__otherDocsRow___PmU4D {
  align-content: center;
  height: 70px;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  align-items: center;
  padding: 0 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.styles__otherDocsRow___PmU4D:last-child {
    border: none;
  }

.styles__otherDocsRow___PmU4D:hover div.styles__remove___r6k0L {
      opacity: 1;
    }

.styles__noDocResults___kDNju {
  color: textLight;
}

.styles__remove___r6k0L {
  opacity: 0;
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___r6k0L a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__leaveNoteIcon___H0YBY {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;
}

.styles__leaveNoteIcon___H0YBY:hover {
    background-color: #e1dfe1;
  }

.styles__actions___ZAVsg {
  display: grid;
  background: white;
  border-bottom: 0;
  /* stylelint-disable */
  grid-template-columns: repeat(2, 1fr);
  /* stylelint-enable */
  margin-bottom: 20px;
  border-radius: 3px;
}

.styles__actions___ZAVsg :nth-child(odd) {
    border-right: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
    border-radius: 3px 0 0 3px;
  }

.styles__actions___ZAVsg :nth-child(even) {
    border-radius: 0 3px 3px 0;
  }

.styles__actionButton___P4iaP {
  display: flex;
  height: 50px;
  color: text;
  cursor: pointer;
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10%;
  width: 100%;
  box-shadow: none;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
}

.styles__actionButton___P4iaP:hover {
    box-shadow: none;
    background: #f8f8f8;
  }

.styles__editButton___uJiLG {
}

.styles__editButton___uJiLG::before {
    content: '';
    height: 100%;
    width: 36px;
    margin-bottom: 2px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
  }

.styles__accountButton___gh907 {
}

.styles__accountButton___gh907::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

.styles__closingFeeButton___qIj44 {
}

.styles__closingFeeButton___qIj44::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }

.styles__closingDateButton___p9po1 {
}

.styles__closingDateButton___p9po1::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }

.styles__buttons___m5L4J {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn____ilfr {
}

.styles__cancelBtn___bKLab {
}

.styles__spacer___gE_p4 {
  display: inline-block;
  width: 1em;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Closings/components/Edit/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,wCAAgC;EAAhC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;EACE,OAAO;AACT;;AAEA;EAEE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;AAEA;;AAEA;EAEE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qEAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AAWb;;AATE;IACE,YAAY;EACd;;AAGE;MACE,UAAU;IACZ;;AAIJ;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,yDAAuD;EACvD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;AAKb;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,aAAa;EACb,iBAAiB;EAEjB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AAUpB;;AARE;IACE,oEAAmC;IACnC,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qEAAoC;AAMtC;;AAJE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;AAGF;AAaA;;AAVE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;EACvB;;AAGF;AAMA;;AAHE;IACE,yDAA0D;EAC5D;;AAGF;AAMA;;AAHE;IACE,yDAAgD;EAClD;;AAGF;AAMA;;AAHE;IACE,yDAAiD;EACnD;;AAGF;EACE,mBAAmB;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value borderColor from colors;\n\n.localHeader {\n  composes: localHeader from helpers;\n}\n\n.localHeaderInner {\n  composes: localHeaderInner from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  flex-direction: column;\n}\n\n.eventsTable {\n  width: 100%;\n}\n\n.nextActionsTable {\n  width: 95%;\n  cursor: pointer;\n}\n\n.section {\n  composes: section from helpers;\n  min-height: 300px;\n}\n\n.sectionTitle {\n  margin-bottom: 20px;\n}\n\n.tableWrapper {\n  lost-column: 2/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n\n.smallFixedCell {\n  width: 50px;\n}\n\n.iconLink {\n  cursor: pointer;\n  text-decoration: none !important;\n  -webkit-box-shadow: none !important;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.title {\n  flex: 1;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.docsWrapper {\n  composes: flexColumn from helpers;\n  background: white;\n  border-radius: 0 0 3px 3px;\n}\n\n.otherDocsRow {\n  align-content: center;\n  height: 70px;\n  border-bottom: 1px solid borderColor;\n  align-items: center;\n  padding: 0 20px;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  width: 100%;\n\n  &:last-child {\n    border: none;\n  }\n\n  &:hover {\n    div.remove {\n      opacity: 1;\n    }\n  }\n}\n\n.noDocResults {\n  composes: sectionNoMargin;\n  color: textLight;\n}\n\n.remove {\n  opacity: 0;\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.leaveNoteIcon {\n  background-image: url('styles/img/icon_leave_note.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    background-color: #e1dfe1;\n  }\n}\n\n.actions {\n  display: grid;\n  background: white;\n  composes: card from helpers;\n  border-bottom: 0;\n  /* stylelint-disable */\n  grid-template-columns: repeat(2, 1fr);\n  /* stylelint-enable */\n  margin-bottom: 20px;\n  border-radius: 3px;\n\n  :nth-child(odd) {\n    border-right: 1px solid borderColor;\n    border-radius: 3px 0 0 3px;\n  }\n\n  :nth-child(even) {\n    border-radius: 0 3px 3px 0;\n  }\n}\n\n.actionButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  cursor: pointer;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 10%;\n  width: 100%;\n  box-shadow: none;\n  border-bottom: 1px solid borderColor;\n\n  &:hover {\n    box-shadow: none;\n    background: #f8f8f8;\n  }\n}\n\n.editButton {\n  composes: actionButton;\n\n  &::before {\n    content: '';\n    height: 100%;\n    width: 36px;\n    margin-bottom: 2px;\n    background-image: url('styles/img/icon_edit.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n  }\n}\n\n.accountButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon_document_gray.png');\n  }\n}\n\n.closingFeeButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-fee.png');\n  }\n}\n\n.closingDateButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-exit.png');\n  }\n}\n\n.buttons {\n  align-items: center;\n  composes: section from helpers;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"localHeader": `styles__localHeader___uYQkz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeader"]}`,
	"localHeaderInner": `styles__localHeaderInner___KZ9n_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeaderInner"]}`,
	"contentContainer": `styles__contentContainer___JP7Iu ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"eventsTable": `styles__eventsTable___bkUtF`,
	"nextActionsTable": `styles__nextActionsTable___kuQ_5`,
	"section": `styles__section___fRz4j ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionTitle": `styles__sectionTitle___TvCN8`,
	"tableWrapper": `styles__tableWrapper___u2wn6`,
	"oneThird": `styles__oneThird___WwVhK`,
	"row": `styles__row___u6G8a`,
	"buttonLocal": `styles__buttonLocal___HWYYk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"smallFixedCell": `styles__smallFixedCell___k8YPZ`,
	"iconLink": `styles__iconLink___awf2T`,
	"collapseRef": `styles__collapseRef___fAoZt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"collapseIcon": `styles__collapseIcon___Gvspn`,
	"title": `styles__title___qEfAc`,
	"titleSection": `styles__titleSection___eu_E3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___Fzce0`,
	"noName": `styles__noName___at_Ox`,
	"sectionNoMargin": `styles__sectionNoMargin___td5ua ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"docsWrapper": `styles__docsWrapper___TNijY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexColumn"]}`,
	"otherDocsRow": `styles__otherDocsRow___PmU4D`,
	"remove": `styles__remove___r6k0L`,
	"noDocResults": `styles__noDocResults___kDNju styles__sectionNoMargin___td5ua ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"leaveNoteIcon": `styles__leaveNoteIcon___H0YBY`,
	"actions": `styles__actions___ZAVsg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"actionButton": `styles__actionButton___P4iaP`,
	"editButton": `styles__editButton___uJiLG styles__actionButton___P4iaP`,
	"accountButton": `styles__accountButton___gh907 styles__editButton___uJiLG styles__actionButton___P4iaP`,
	"closingFeeButton": `styles__closingFeeButton___qIj44 styles__editButton___uJiLG styles__actionButton___P4iaP`,
	"closingDateButton": `styles__closingDateButton___p9po1 styles__editButton___uJiLG styles__actionButton___P4iaP`,
	"buttons": `styles__buttons___m5L4J ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"removeBtn": `styles__removeBtn____ilfr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___bKLab ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"spacer": `styles__spacer___gE_p4`
};
export default ___CSS_LOADER_EXPORT___;
